import { render, staticRenderFns } from "./ComHeranca.vue?vue&type=template&id=8c712e44&scoped=true"
import script from "./ComHeranca.vue?vue&type=script&lang=js"
export * from "./ComHeranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c712e44",
  null
  
)

export default component.exports